// Compiled at 2026-05-13T13:50:05.286Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Common, Common as This, System } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { ResourceDefinition } from "@lg/shared";

export class $Resources {
    static readonly MainCss: ResourceDefinition<'client', 'downloadable'> = {
        resourceType: 'text/css',
        mimeType: 'text/css',
        fileName: 'main.css',
        relativeUrl: '/master/Llama/Common.MainCss/main.css',
        get absoluteUrl() { return `${System.$Config.Environment.publicUrl}/master/Llama/Common.MainCss/main.css` },


    };
    static readonly Logo: ResourceDefinition<'client', 'downloadable'> = {
        resourceType: 'image/png',
        mimeType: 'image/png',
        fileName: 'generic_logo.png',
        relativeUrl: '/master/Llama/Common.Logo/generic_logo.png',
        get absoluteUrl() { return `${System.$Config.Environment.publicUrl}/master/Llama/Common.Logo/generic_logo.png` },


    };
}
